import React from "react";
import rojilImage from "../../../assets/images/our-team/rojil.png";
import TeamCard from "./TeamCard";

const team = [
  {
    name: "Arun Purushothaman",
    role: "CEO",
    image: "https://pixl.ai/assets/images/our-team/officialMem/arun.png",
    bio: "Leading innovation in cognitive computing",
  },
  {
    name: "Abhilash Mathew",
    role: "CTO",
    image: "https://pixl.ai/assets/images/our-team/officialMem/abhilash.png",
    bio: "Technical visionary and AI expert",
  },
  // {
  //   name: "Rojil Thomas",
  //   role: "Head of Product",
  //   image: rojilImage,
  //   bio: "Product strategy and innovation leader",
  // },
];

const TeamSection = () => {
  return (
    <div className="position-relative">
      <div className="position-relative mb-2">
        <h2 className="font_600 mb-0 HomeBannerText ourproductMainhead font_14 line_height1_7 text-black text-center pt-2">
          Our Leadership Team
        </h2>
        <h3 className="ourProductPositionhead mb-0 font_600 w-100 text-center">
          Our Leadership Team
        </h3>
      </div>
      <div className="row g-4 mt-5 justify-content-center">
        {team.map((member, index) => (
          <TeamCard key={index} member={member} />
        ))}
      </div>
    </div>
  );
};

export default TeamSection;
